<div class="mapContainer" [id]="mapContainerName" *ngIf="showMap"></div>

<div class="placeHolder" *ngIf="!showMap">
  <span [innerHtml]="'showmap_test_1' | translate"></span>
  <div class="switch-container-in" style="justify-content: center">
    <dx-switch [value]="showMap" (onValueChanged)="onSwitchChanged($event)"></dx-switch>
    <span class="switch-span-in"[innerHtml]="'switch_showmap_text_on' | translate"></span>
  </div>
</div>

<div *ngIf="showMap">
  <div class="switch-container-out">
    <dx-switch [value]="showMap" (onValueChanged)="onSwitchChanged($event)"></dx-switch>
    <span class="switch-span-out" [innerHtml]="'switch_showmap_text_off' | translate"></span>
  </div>
</div>
